module.exports = __webpack_public_path__ + "static/chris-0f2f36138978448637b5b3b7653bd4f0.jpg";